/*document.addEventListener('DOMContentLoaded', function () {
	setTimeout(function () {
		const matches = document.querySelectorAll('.code textarea');
		console.log(matches);
		console.log(Prism);
		console.log('Test');
		matches.forEach((userItem) => {
			userItem.addEventListener('keydown', function (e) {
				if (e.key === 'Tab') {
					e.preventDefault();
					var start = this.selectionStart;
					var end = this.selectionEnd;

					// set textarea value to: text before caret + tab + text after caret
					this.value =
						this.value.substring(0, start) +
						'\t' +
						this.value.substring(end);

					// put caret at right position again
					this.selectionStart = this.selectionEnd = start + 1;
				}
			});

			// Create a div for displaying the highlighted code
			const pre = document.createElement('pre');
			const code = document.createElement('code');
			code.classList.add('language-javascript'); // Change 'javascript' to whatever language you need
			pre.appendChild(code);
			userItem.parentNode.insertBefore(pre, userItem.nextSibling);

			// Update the highlighted code on input
			userItem.addEventListener('input', function () {
				code.textContent = userItem.value;
				Prism.highlightElement(code);
			});

			// Initial highlighting
			code.textContent = userItem.value;
			Prism.highlightElement(code);
		});
	}, 10000); // 10 seconds delay
});
*/
// Make it so that inside .code textarea's the tab key will insert a tab character instead of moving focus to the next element
document.addEventListener('DOMContentLoaded', function () {
	const matches = document.querySelectorAll('.code textarea');
	matches.forEach((userItem) => {
		userItem.addEventListener('click', function () {
			userItem.removeEventListener('click', arguments.callee);
			userItem.addEventListener('keydown', function (e) {
				if (e.key === 'Tab') {
					e.preventDefault();
					var start = this.selectionStart;
					var end = this.selectionEnd;

					// set textarea value to: text before caret + tab + text after caret
					this.value =
						this.value.substring(0, start) +
						'\t' +
						this.value.substring(end);

					// put caret at right position again
					this.selectionStart = this.selectionEnd = start + 1;
				}
			});
		});
	});

	const buttons = document.querySelectorAll(
		'.components-toolbar-group button'
	);
	buttons.forEach((button) => {
		button.addEventListener('click', function () {
			const matches = document.querySelectorAll('.code textarea');
			matches.forEach((userItem) => {
				userItem.addEventListener('keydown', function (e) {
					if (e.key === 'Tab') {
						e.preventDefault();
						var start = this.selectionStart;
						var end = this.selectionEnd;

						// set textarea value to: text before caret + tab + text after caret
						this.value =
							this.value.substring(0, start) +
							'\t' +
							this.value.substring(end);

						// put caret at right position again
						this.selectionStart = this.selectionEnd = start + 1;
					}
				});
			});
		});
	});
});
